import { MenuRow } from '@repo/studio-components-menu-row'
import { Tooltip } from 'primitives/tooltip'
import * as React from 'react'
import {
  useStudioMatchPath,
  useStudioPathname,
  StudioLayoutLink,
} from '@repo/studio-config/studio-config-router'
import type { AppSwitchBarItem } from '@repo/studio-components/top-app-bar/components/app-switch-bar'
import { FavoriteToolButton } from '@repo/studio-components/tools/favorite-tool-button'

export function NavigationItem({
  className,
  title,
  route,
  expanded,
  icon,
  onNavigate,
  exact = false,
  hardNavigation = false,
  tool,
}: {
  className?: string
  title: string
  route: string
  expanded: boolean
  icon: React.ReactNode
  onNavigate?: () => void
  exact?: boolean
  hardNavigation?: boolean
  tool?: AppSwitchBarItem
}) {
  const pathname = useStudioPathname()
  const matchPath = useStudioMatchPath()
  const isHardNavigation = hardNavigation || Boolean(tool?.hardNavigation)
  const isSelected = isHardNavigation ? false : matchPath({ path: route, end: exact }, pathname)

  const menuRow = (
    <MenuRow asChild variant="slim" key={title} className={className} selected={isSelected}>
      <MenuRow.Link asChild onClick={onNavigate}>
        <StudioLayoutLink
          aria-current={isSelected ? 'page' : undefined}
          to={route}
          reloadDocument={isHardNavigation}
        >
          <MenuRow.Icon data-navigation-icon>{icon}</MenuRow.Icon>
          {expanded ? (
            <>
              <MenuRow.Label>{title}</MenuRow.Label>
              {tool && !tool.hideFavorite ? <NavFavoriteToolButton tool={tool} /> : null}
            </>
          ) : null}
        </StudioLayoutLink>
      </MenuRow.Link>
    </MenuRow>
  )

  return (
    <Tooltip
      value={title}
      side="right"
      sideOffset={8}
      delay={0}
      className="bg-gray-50 text-gray-1000 rounded-2 px-2 py-0 mb-0 h-[30px] flex items-center justify-center typography-12"
      arrowClassName="fill-gray-50"
      open={expanded ? false : undefined}
    >
      <div>{menuRow}</div>
    </Tooltip>
  )
}

function NavFavoriteToolButton({ tool }: { tool: AppSwitchBarItem }) {
  return (
    <div
      className="lg:group-hover/row:opacity-100 lg:opacity-0 transition-opacity"
      onClick={e => e.stopPropagation()}
    >
      <FavoriteToolButton tool={tool} size="xs" variant="ghost" />
    </div>
  )
}
